import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api";

export const doGetAllMessageLogs = createAsyncThunk("drivers/getAllMessageLogs", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getAllMessageLogs(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
